import * as glb from '../globals.js';

export const OPEN_SABIT_DEFINITIONS_EVENT = 'open-sabit-definitions';

export function isGeneralYetkiUser() {
    const user = glb.default?.KULLANICI || {};
    return Number(user.KUL_YETKI) === 0 || Number(user.KUL_YS) === 0 || !!user.KUL_ISADMIN;
}

export function detectSabitStTur(items) {
    const rows = Array.isArray(items) ? items.filter(Boolean) : [];
    if (!rows.length || !rows.every((row) => row.ST_TUR != null && row.ST_AD != null)) return null;
    const first = Number(rows[0].ST_TUR);
    if (!Number.isFinite(first) || !rows.every((row) => Number(row.ST_TUR) === first)) return null;
    return first;
}

export function currentSabitItems(stTur) {
    return (glb.default?.sabitLkp || []).filter((row) => Number(row.ST_TUR) === Number(stTur) && !row.ST_SIL);
}

export function openSabitDefinitions(stTur) {
    window.dispatchEvent(new CustomEvent(OPEN_SABIT_DEFINITIONS_EVENT, { detail: { stTur: Number(stTur) } }));
}

export function sabitDefinitionEditorButtons(stTur, showClearButton = false) {
    if (!isGeneralYetkiUser()) return undefined;
    return [
        ...(showClearButton ? ['clear'] : []),
        {
            name: `sabit-definition-${Number(stTur)}`,
            location: 'after',
            options: {
                text: 'T',
                hint: 'Sabit tanım ekranı',
                type: 'success',
                stylingMode: 'contained',
                elementAttr: { 'aria-label': 'Sabit tanım ekranı' },
                onClick: () => openSabitDefinitions(stTur),
            },
        },
        'dropDown',
    ];
}
